export const locale = {
    lang: 'de',
    data: {
      'MODALES': {
        'ERROR_DATOS':'Ein Fehler ist aufgetreten A-721',
        'VALIDACION':{
          'ERROR1':'Sie haben eine Frage ohne Übersetzung',
          'WARNUNG-SIN-TRADUCCION':'Bitte fügen Sie Ihre Reagenzienübersetzung hinzu',
          'MODAL-GUARDANDO':'Reaktiv speichern'
        },
        'TITULO':'Es ist ein Fehler aufgetreten',
        'TITULOS': {
          'error': 'An error ocurred',
          'adver': 'Warnung',
          'aviso': 'Warnung',
          'opSuc': 'Aktion abgeschlossen'
        },
        'ACCIONES': {
          'aceptar': 'Akzeptieren',
          'cancelar': 'Abbrechen',
          'INFORMATIVO': 'Diese Meldung nicht mehr anzeigen'
        },
        'EXPEDIENTES':{
          'Resultados': 'Das Ergebnis liegt noch nicht vor',
          'CARGANDO_COLABORADORES':'Mitarbeiter laden, die ärztliche Aufsicht benötigen',
        },
        'MENSAJES': {
          'NO_FECH_LAN':'Unvollständige Daten, Produktfreigabedatum auswählen',
          'NO_RESU_ACTI':'Im Moment sind die Ergebnisse nicht verfügbar, bitte versuchen Sie es später noch einmal',
          'OK':'OK',
          'Etwas ist falsch': 'Etwas ist falsch',
          'Passwort falsch': 'Das eingegebene Passwort ist falsch',
          'Benutzer existiert nicht': 'Die von Ihnen eingegebene E-Mail ist nicht in CulturalGO registriert',
          '150': 'die Collabs wurden gespeichert :V',
          'Fehler: Benutzer existiert bereits': 'Der Benutzer mit dieser E-Mail existiert bereits',
          'CONEX': {
            'SIN': 'Ihr Gerät hat keine Internetverbindung mehr, Um die Plattform weiter zu nutzen, verbinden Sie Ihr Gerät mit dem Internet',
            'CON': 'Ihr Gerät hat die Internetverbindung wiederhergestellt\n\nNun können Sie die Plattform weiter nutzen'
          },
          'WIZARD': {
            'CERTIFICAR': {
              'RESTRICCIONES': {
                'rest1': 'Um auf diesen Bereich zugreifen zu können, müssen Sie die <b>Sprachen</b> für die Umfrage einstellen',
                'rest2': 'Um auf diesen Bereich zugreifen zu können, müssen Sie alle vorherigen Schritte ausführen',
                'rest3': 'Um auf diesen Abschnitt zuzugreifen, müssen Sie den Start der Umfrage <b>planen</b>',
                'rest4': 'Um auf diesen Bereich zugreifen zu können, müssen Sie den <b>E-Mail-Versand</b> durchgeführt haben und die Umfrage muss gestartet worden sein',
                'rest5': 'Um auf diesen Bereich zugreifen zu können, müssen Sie die <b>Demografien</b> für die Umfrage festlegen'
              },
              'IDIOMAS': {
                'NADA': 'Sie haben die Sprachauswahl nicht gestartet',
                'NADA2': 'Sie haben die Terminerinnerung noch nicht gestartet',
                'NADA4': 'Sie haben die Terminerinnerung noch nicht gestartet',
                'NODEFAULT': 'Sie haben die Hauptsprache noch nicht ausgewählt',
                'NOADICIONAL': 'Sie haben noch keine zusätzliche Sprache ausgewählt',
                'COMPLETAR': 'Sind Sie sicher, dass Sie diesen Schritt mit der aktuellen Sprachauswahl als abgeschlossen markieren wollen?',
                '210': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt können Sie die Hauptsprache und weitere Sprachen auswählen, in denen die Umfrage den Mitarbeitern präsentiert wird',
                'ARCHIVOCOMFIRM': 'Achtung! Stellen Sie sicher, dass Sie die Excel-Datei auf einem einzigen Betriebssystem bearbeiten, um Codierungskonflikte zu vermeiden.',
                'BOTONTEXTO': 'Verstanden',

                'TITULO_DESBLOQUEAR': '<span>Sind Sie sicher, dass Sie die Sprachpassagen erneut öffnen wollen, beachten Sie, dass dies <font color="red">Ihr aktuelles Produkt neu startet</font> und alle Informationen löscht, die Sie zu den Abschnitten hinzugefügt haben?</span>',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wieder geöffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'TEMPLATE': {
                // 'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                // 'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                // 'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                // 'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                // '210': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'In diesem Abschnitt können Sie Änderungen an der Vorlage vornehmen',
                // 'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                // 'BOTONTEXTO':'Enterado',

                // 'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'NPS': {
                'NADA': 'Sie haben keinen NPS angelegt oder die Option ohne NPS markiert',
                'COMPLETAR': 'Sind Sie sicher, dass Sie den Schritt mit Ihrem aktuellen NPS abschließen können?',
                '219': 'Der Schritt wurde erfolgreich abgeschlossen',
                '220': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt können Sie Ihren NPS für die Umfrage ändern',
                'FALTANTES': 'Sie haben das Ausfüllen Ihres NPS noch nicht abgeschlossen',
                'FALTANTES_TRADUCCIONES': 'Sie haben die Übersetzungen für alle Fragen noch nicht vollständig ausgefüllt',
                'FALTANTES_SECCIONES_ESPECIALES': 'Sie haben den Schlüssel des Sonderbereichs noch nicht eingegeben',
                'FALTANTES_RESPUESTAS': 'Sie können diesen Schritt noch nicht ausführen. Alle Fragen mit mehreren Optionen müssen mindestens zwei Antwortoptionen enthalten',
                'SIN_PREGUNTAS': 'Sie müssen mindestens eine Frage hinzufügen, um den Schritt abzuschließen',
                'SIN_GRUPOS': 'Sie müssen mindestens eine Fragengruppe mit einer Frage hinzufügen, um den Schritt abzuschließen',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den NPS-Schritt erneut öffnen wollen?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'REACTIVOS': {
                'NADA': 'Sie haben keine Anweisungen erstellt oder die Option ohne Anweisungen markiert',
                'COMPLETAR': 'Sind Sie sicher, dass Sie diesen Schritt mit den aktuellen Anweisungen als abgeschlossen markieren wollen?',
                '218': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt können Sie Aussagen zur Umfrage hinzufügen',
                'FALTANTES': 'Sie haben das Ausfüllen Ihrer Aussagen noch nicht abgeschlossen',
                'FALTANTES_TRADUCCIONES': 'Sie haben die Übersetzungen für alle Fragen noch nicht vollständig ausgefüllt',
                'FALTANTES_SECCIONES_ESPECIALES': 'Sie haben den Schlüssel des Sonderbereichs noch nicht eingegeben',
                'FALTANTES_RESPUESTAS': 'Sie können diesen Schritt noch nicht ausführen. Alle Fragen mit mehreren Optionen müssen mindestens zwei Antwortoptionen enthalten',
                'SIN_PREGUNTAS': 'Sie müssen mindestens eine Frage hinzufügen, um den Schritt abzuschließen',
                'SIN_GRUPOS': 'Sie müssen mindestens eine Fragengruppe mit einer Frage hinzufügen, um den Schritt abzuschließen',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den Schritt Aussagen erneut öffnen möchten?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'FORALL': {
                'NADA': 'Sie haben die Befüllung der 4ALL-Übungen noch nicht abgeschlossen',
                'COMPLETAR': 'Sind Sie sicher, dass Sie diesen Schritt mit den aktuellen For All-Praktiken als abgeschlossen markieren wollen?',
                '212': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion durchzuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'Dieser Abschnitt listet die im Unternehmen durchgeführten Praktiken auf, die die Beteiligung aller Mitarbeiter beinhalten',
                'NADA_TRA': 'Sie haben die Übersetzung Ihrer 4ALL-Praktiken noch nicht abgeschlossen',
                'FALTANTES_TRADUCCIONES': 'Sie haben die Übersetzungen für alle Fragen noch nicht vollständig ausgefüllt',
                'FALTANTES_SECCIONES_ESPECIALES': 'Sie haben den Schlüssel des Sonderbereichs noch nicht eingegeben',
                'FALTANTES_RESPUESTAS': 'Sie können diesen Schritt noch nicht ausführen. Alle Fragen mit mehreren Optionen müssen mindestens zwei Antwortoptionen enthalten',
                'SIN_PREGUNTAS': 'Sie müssen mindestens eine Frage hinzufügen, um den Schritt abzuschließen',
                'SIN_GRUPOS': 'Sie müssen mindestens eine Fragengruppe mit einer Frage hinzufügen, um den Schritt abzuschließen',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den Schritt 4ALL-Praktiken erneut öffnen möchten?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'CONTROL': {
                'NADA': 'Sie haben keine Kontrollfragen erstellt oder die Option ohne Kontrolle markiert',
                'COMPLETAR': 'Sind Sie sicher, dass Sie den Schritt mit Ihrer aktuellen Kontrollfrage abschließen wollen?',
                '221': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt können Sie Ihre Umfragekontrollfrage ändern',
                'FALTANTES': 'Sie haben das Ausfüllen Ihrer Kontrollfrage noch nicht abgeschlossen',
                'FALTANTES_TRADUCCIONES': 'Sie haben die Übersetzungen für alle Fragen noch nicht vollständig ausgefüllt',
                'FALTANTES_SECCIONES_ESPECIALES': 'Sie haben den Schlüssel des Sonderbereichs noch nicht eingegeben',
                'FALTANTES_RESPUESTAS': 'Sie können diesen Schritt noch nicht ausführen. Alle Fragen mit mehreren Optionen müssen mindestens zwei Antwortoptionen enthalten',
                'SIN_PREGUNTAS': 'Sie müssen mindestens eine Frage hinzufügen, um den Schritt abzuschließen',
                'SIN_GRUPOS': 'Sie müssen mindestens eine Fragengruppe mit einer Frage hinzufügen, um den Schritt abzuschließen',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den Schritt Kontrollfrage erneut öffnen möchten?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'DEMOGRAFICOS': {
                'NADA': 'Sie haben noch keine demografischen Daten ausgewählt',
                'COMPLETAR': 'Sind Sie sicher, dass dieser Schritt mit den aktuellen demografischen Informationen als abgeschlossen markiert werden soll?',
                '213': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt werden die demografischen Optionen festgelegt, die den Mitarbeitern in der Umfrage zur Verfügung gestellt werden',
                'FALTANTES_TRADUCCIONES': 'Sie haben die Übersetzungen für alle Fragen noch nicht vollständig ausgefüllt',
                'FALTANTES_SECCIONES_ESPECIALES': 'Sie haben den Schlüssel des Sonderbereichs noch nicht eingegeben',
                'FALTANTES_RESPUESTAS': 'Sie können diesen Schritt noch nicht ausführen. Alle Fragen mit mehreren Optionen müssen mindestens zwei Antwortoptionen enthalten',
                'SIN_PREGUNTAS': 'Sie müssen mindestens eine Frage hinzufügen, um den Schritt abzuschließen',
                'SIN_GRUPOS': 'Sie müssen mindestens eine Fragengruppe mit einer Frage hinzufügen, um den Schritt abzuschließen',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den Demografieschritt erneut öffnen möchten?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wieder geöffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'ABIERTAS': {
                'NADA': 'Sie haben keine offene Frage angelegt oder die Option ohne offene Fragen markiert',
                'COMPLETAR': 'Sind Sie sicher, dass Sie diesen Schritt mit den aktuellen offenen Fragen als abgeschlossen markieren wollen?',
                '220': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion durchzuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt können Sie offene Fragen hinzufügen, um ein schriftliches Feedback Ihrer Mitarbeiter zu erhalten',
                'FALTANTES': 'Sie haben das Ausfüllen Ihrer offenen Fragen noch nicht abgeschlossen',
                'FALTANTES_TRADUCCIONES': 'Sie haben die Übersetzungen für alle Fragen noch nicht vollständig ausgefüllt',
                'FALTANTES_RESPUESTAS': 'Sie können diesen Schritt noch nicht ausführen. Alle Fragen mit mehreren Optionen müssen mindestens zwei Antwortoptionen enthalten',
                'SIN_PREGUNTAS': 'Sie müssen mindestens eine Frage hinzufügen, um den Schritt abzuschließen',
                'SIN_GRUPOS': 'Sie müssen mindestens eine Fragengruppe mit einer Frage hinzufügen, um den Schritt abzuschließen',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den Schritt der offenen Fragen erneut öffnen möchten?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'ADICIONALES': {
                'NADA': 'Sie haben keine Zusatzfrage erstellt oder die Option ohne Zusatzfragen markiert',
                'COMPLETAR': 'Sind Sie sicher, dass Sie diesen Schritt mit den aktuellen Zusatzfragen als abgeschlossen markieren wollen?',
                '214': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion durchzuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt können Sie der Umfrage benutzerdefinierte Fragen hinzufügen',
                'FALTANTES_TRADUCCIONES': 'Sie haben die Übersetzungen für alle Fragen noch nicht vollständig ausgefüllt',
                'FALTANTES_SECCIONES_ESPECIALES': 'Sie haben den Schlüssel des Sonderbereichs noch nicht eingegeben',
                'FALTANTES_RESPUESTAS': 'Sie können diesen Schritt noch nicht ausführen. Alle Fragen mit mehreren Optionen müssen mindestens zwei Antwortoptionen enthalten',
                'SIN_PREGUNTAS': 'Sie müssen mindestens eine Frage hinzufügen, um den Schritt abzuschließen',
                'SIN_GRUPOS': 'Sie müssen mindestens eine Fragengruppe mit einer Frage hinzufügen, um den Schritt abzuschließen',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den zusätzlichen Schritt erneut öffnen möchten?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'COLABORADORES': {
                'NADA': 'Sie haben Ihre Teilnehmerdatenbank nicht geladen',
                'COMPLETAR': 'Sind Sie sicher, dass Sie diesen Schritt mit der aktuellen Teilnehmerdatenbank als abgeschlossen markieren wollen?',
                '211': 'Der Schritt wurde erfolgreich abgeschlossen',
                '200': 'Der Schritt wurde erfolgreich abgeschlossen',
                '219': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt wird die Liste der Mitarbeiter geladen, an die die Einladung zur Umfrage per E-Mail gesendet wird',
                'ACTUALIZAR': 'Mitarbeiter wurden korrekt zur Umfrage hinzugefügt',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den Schritt Teilnehmer erneut öffnen möchten?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'PROGRAMACION': {
                'NADA': 'Sie haben keinen Termin geplant',
                'COMPLETAR': 'Sind Sie sicher, dass dieser Schritt mit dem aktuellen Termin als erledigt markiert werden soll?',
                'GENERAR': 'Sind Sie sicher, dass dieser Schritt als abgeschlossen markiert werden soll?',
                '215': 'Der Schritt wurde erfolgreich abgeschlossen',
                '217': 'Der Schritt wurde erfolgreich beendet', //CERTIFICAR2.0
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'FECHALANZAMIENTO': 'Sie haben Ihr Freigabedatum noch nicht eingegeben',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt werden die Termine für den Start und das Versenden von Erinnerungen für den Abschluss der Umfrage festgelegt',
                'INFORMATIVO2': 'In diesem Abschnitt werden die Termine für das Versenden von Umfragen Pulse Check festgelegt',
                'GUARDA-OK':'Das Datum wurde erfolgreich gespeichert',
                'OK':'OK',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den Schritt Umfrage erstellen erneut öffnen wollen?',
                'TITULO_DESBLOQUEAR2': 'Sind Sie sicher, dass Sie den geplanten Umfrageschritt erneut öffnen wollen?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen',
                'NOT_MESS_COM':'Diese Funktion ist nicht erlaubt',
                'DETEC_CAMBIOS_SECCIONES':'SWurden Änderungen in der Konfiguration der Abschnitte festgestellt, erzeugen Sie die Umfrage erneut.',
              },
              'ENVIO': {
                'NADA': 'Sie haben den E-Mail-Versand der Umfrageeinladung an Ihre Mitarbeiter noch nicht durchgeführt',
                'NADA_OPCION': 'Sie haben noch nicht konfiguriert, ob die Einladung per E-Mail versendet werden soll',
                'COMPLETAR': 'Sind Sie sicher, dass dieser Schritt als abgeschlossen markiert werden soll?',
                '216': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt können Sie die Einladungen zur Pilotumfrage versenden',

                'TITULO_DESBLOQUEAR': 'Sind Sie sicher, dass Sie den Schritt Mailversender erneut öffnen wollen?',
                'BOTON_CONFIRM': 'Ja, wieder öffnen',
                'BOTON_CANCEL': 'Abbrechen',
                'SUCCES': 'Der Schritt wurde erfolgreich wiedereröffnet',
                'BLOQUEADO': 'Der Schritt ist jetzt geöffnet',
                'CERRAR': 'Schließen'
              },
              'CONFIRMACION': {
                // 'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                // 'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                // 'COMPLETAR': '¿Está seguro de completar el paso?',
                // '216': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                 'INFORMATIVO': 'In diesem Bereich können Sie die Umfrage aktivieren oder deaktivieren.',
                // 'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'CIERRE': {
                'NADA': 'Die Umfrage ist noch nicht beendet',
                'COMPLETAR': 'Sind Sie sicher, dass dieser Schritt als abgeschlossen markiert werden soll?',
                '217': 'Der Schritt wurde erfolgreich abgeschlossen',
                'COMPLETADO': 'Sie haben diesen Schritt bereits abgeschlossen',
                'RESTRICCION': 'Es ist nicht möglich, diese Aktion auszuführen, wenn Sie diesen Schritt abgeschlossen haben',
                'INFORMATIVO': 'In diesem Abschnitt kann der aktuelle Fortschritt der Umfrage eingesehen werden, sowie das vorzeitige Beenden der Umfrage',
                'INFORMATIVO2': 'In diesem Abschnitt können Sie den aktuellen Fortschritt jeder der gestarteten Pulse Check-Umfragen einsehen'
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': 'Warnung',
                  'INFO': 'Warnung\n\nIhre Sitzung wird geschlossen und die Plattform wird mit der Anmeldung als ausgewählter Arbeitsplatz fortfahren.\n\nBestätigen Sie die Anmeldung als ausgewählter Arbeitsplatz?',
                  'INFOODS': 'Warnung\n\nIhre Sitzung wird geschlossen und die Plattform fährt mit der Anmeldung als ausgewähltes Unternehmen fort.\n\nBestätigen Sie die Anmeldung als ausgewähltes Unternehmen?'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'Noch nicht autorisiert',
              'BTN-ENTERADO':'ENTER',
              'MODAL-AUTORIZACION':'Ihre Umfrage wurde zur Validierung gesendet',



            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': 'Ihr Computer oder Gerät weist einen Verbindungsfehler mit der Plattform auf, bitte versuchen Sie, später erneut zuzugreifen',
          '102': 'Die eingegebene E-Mail-Adresse ist nicht in CulturalGO registriert',
          '103': 'Das eingegebene Passwort ist falsch',
          '101': 'Der Benutzer mit dieser E-Mail existiert bereits',
          // 'verifyToken_3': '<span>Die Plattform wurde kürzlich aktualisiert, aus diesem Grund und um Informationsverluste zu vermeiden, wird Ihre Sitzung geschlossen<br><br>Um die einwandfreie Funktion der Plattform zu gewährleisten, bitten wir Sie, vor dem erneuten Zugriff Ihren Browser mit der Tastenkombination <font color="red">CTRL + F5</font> zu aktualisieren.</span>',
          // 'tokenActLogin': '<span>Die Plattform hat kürzlich ein Update erhalten, aus diesem Grund und um die korrekte Funktion der Plattform zu gewährleisten, bitten wir Sie, Ihren Browser mit der Tastenkombination <font color="red">CTRL + F5</font> zu aktualisieren, danach können Sie normal auf die Plattform zugreifen</span>'
          'verifyToken_3': '<span>Die Plattform wurde kürzlich aktualisiert, aus diesem Grund und um Informationsverluste zu vermeiden, wird Ihre Sitzung geschlossen<br><br>Um die ordnungsgemäße Funktion der Plattform zu gewährleisten, wird <font color="red">Ihr Browser automatisch aktualisiert</font></span>',
          'tokenActLogin': '<span>Die Plattform hat kürzlich ein Update erhalten, aus diesem Grund und um die korrekte Funktion der Plattform zu gewährleisten, <font color="red">wird Ihr Browser automatisch aktualisiert</font>, danach können Sie normal auf die Plattform zugreifen</span>',
          'Demo keys out of stock': 'Umfrage Demo-Benutzer sind erschöpft',
          'Keys Out Of Stock': 'Umfrage Demo-Benutzer sind erschöpft',
          'Error: Please Recreate Survey':'Es wurden Änderungen in den Fragen festgestellt.\n\n Um fortzufahren, erstellen Sie bitte die Umfrage neu.',
          'IT Manager Not Found':'Die E-Mail wurde nicht an den IT-Manager gesendet.\n\ngeben Sie die E-Mail ein und senden Sie sie manuell.',
          'NO_PROCC_PROD_ASO':'Das zugehörige Produkt wurde zu diesem Zeitpunkt noch nicht bearbeitet',
          'ERR_PROCC_PROD_ACT':'Fehler beim Aktualisieren von Benutzern in SQL',
          '300':'Die eingegebene E-Mail hat keine Zugriffsrechte',
        },
        'ELIMINAR':{
          'MENSAJETEXTO1': '<span>Um den Abgang der Firma zu bestätigen, ',
          'MENSAJETEXTO2': ', geben Sie den Firmennamen in das Textfeld ein</span>',
          'SALIR': 'Beenden',
          'VALIDAR': 'Firma bestätigen',
          'ERRORNOMBREEMPRESA': 'Der Name der eingegebenen Firma stimmt nicht mit dem Namen der zu löschenden Firma überein',
          'MENSAJE': 'Sind Sie sicher?\n\nSie sind im Begriff, die Firma zu löschen',
          'CANCELAR': 'Abbrechen',
          'CONFIRMAR': 'Ja, löschen',
          'SUCCES': 'Firma eliminiert',
          'CERRAR': 'Schließen'
        },
        'LOG_SENDGRIND':{
          'CARGANDO': 'Daten werden geladen, bitte warten...',
          'ASUNTO': 'Sie müssen einen Betreff auswählen',
          'CONFIRMAR': 'Schließen'
        }
      }
    }
};
